import { render, staticRenderFns } from "./chooseMaterials.vue?vue&type=template&id=e25e7c82&scoped=true"
import script from "./chooseMaterials.vue?vue&type=script&lang=js"
export * from "./chooseMaterials.vue?vue&type=script&lang=js"
import style0 from "./chooseMaterials.vue?vue&type=style&index=0&id=e25e7c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25e7c82",
  null
  
)

export default component.exports